const enum Method {
    GET = "GET",
    POST = "POST",
}

const enum ContentType {
    json = "application/json",
    csv = "text/csv",
    xml = "text/xml",
    html = "text/html",
    excel = "application/vnd.ms-excel",
    text = "text/plain",
}

const enum ContentDisposition {
    attachment = "attachment",
}
const HOME_URL = "https://modoomap.com";

// 백엔드 API 서버 주소
const BASE_URL = "https://modoomap.com/api"; // v2 서버 배포 Version
// const DEV_BASE_URL = "https://30.30.30.22:8543/api"; // Test 배포 Version
// const DEV_BASE_URL = "https://30.30.30.17:8446/api"; // 로컬 개발 시 Test 배포 Version에서 본인 ip로 변경하여 사용
const DEV_BASE_URL = "http://localhost:8080/api";

export { Method, ContentType, ContentDisposition, HOME_URL, BASE_URL, DEV_BASE_URL };
